export const NODE_WIDTH = 200;
export const COLUMN_GAP = 72;
export const ROW_GAP = 132;
export const ROOT_Y = 0;
export const GRID_TOP = 130;
export const MAX_COLUMNS = 8;
export const TARGET_ASPECT = 3.6;
export const OVERLAY_Z = 20;

export const ZONE_ROWS = 2;
export const ZONE_WIDTH = NODE_WIDTH + 120;
export const ZONE_LEFT_OFFSET = NODE_WIDTH + 160;
export const ZONE_TOP_OFFSET = -120;
export const TITLE_SLOT_HEIGHT = 96;
export const ZONE_ROW_GAP = 70;

export const GHOST_COUNT = 4;
export const GHOST_ZONE_SLOTS = 2;
export const OVERLAY_PAGE_SIZE = 25;
export const FIELD_FOCUS_TOP_VALUES = 8;
export const STAGE_Z = 40;
